function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as parkingLotApi from '@/api/parkingLotApi';
import { Debounce } from '@/utils/validate';
export default {
  name: 'ParkingLotDialog',
  data: function data() {
    return {
      visible: false,
      loading: false,
      pram: {}
    };
  },
  methods: {
    open: function open() {
      var _this = this;
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (data.id) {
        this.pram = _objectSpread({}, data);
      } else {
        this.pram = {
          parkName: '',
          parkCode: ''
        };
      }
      this.visible = true;
      this.$nextTick(function () {
        if (_this.$refs.pram) {
          _this.$refs.pram.clearValidate();
        }
      });
    },
    handleSubmit: Debounce(function () {
      var _this2 = this;
      this.$refs.pram.validate(function (valid) {
        if (!valid) return;
        _this2.loading = true;
        var params = _objectSpread({}, _this2.pram);
        var api = params.id ? parkingLotApi.updateParkingLot : parkingLotApi.addParkingLot;
        api(params).then(function () {
          _this2.$message.success('操作成功');
          _this2.loading = false;
          _this2.visible = false;
          _this2.$emit('refresh');
        }).catch(function () {
          _this2.loading = false;
        });
      });
    }),
    closeDialog: function closeDialog() {
      this.visible = false;
    }
  }
};